export const delayPromise = delay => new Promise(resolve => setTimeout(resolve, delay));
